import { render } from "preact";
import { App } from "./app/App";
import "./app/styles.css";

const root = document.getElementById("app");

if (!root) {
  throw new Error("Elemento raiz da aplicação não encontrado.");
}

render(<App />, root);
